import Carousel from './CarouselFigure';
export default Carousel;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-carousel/src/index.js